import {createSlice, Draft, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@app/store";
import ProfileInterface from "@features/share/models/ProfileInterface";

interface profileState {
  profile: ProfileInterface,
}

const initialState: profileState = {
  profile: null,
}

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile(state: profileState, action: PayloadAction<ProfileInterface>){
      state.profile = action.payload
    },
  }
})

export function getProfile(state: RootState){
  return state.profile.profile
}

export const { setProfile } = profileSlice.actions

export const selectProfile = (state: RootState) => state.profile.profile

const profileReducer = profileSlice.reducer

export default profileReducer